class AppDropzone {

    init(el) {
        return jQuery(el).dropzone({
            url: el.uploadUrl,
            params: el.params,
            createImageThumbnails: false,
            clickable: el.clickable,
            previewTemplate: null,
            acceptedFiles: el.acceptedFiles,
            uploadMultiple: true,
            parallelUploads: 1,
            timeout: false,
            addedfile(file) {
                if (el.progressBar) {
                    el.progressBar.classList.remove("failure");
                    el.progressBar.classList.add("running");
                }
            },
            totaluploadprogress(progress) {
                if (el.progressBar && el.progress < progress) {
                    el.progress = progress;
                    el.progressBar.innerHTML = parseInt(progress) + "%&nbsp;";
                    el.progressBar.style.width = parseInt((el.progressBar.parentElement.offsetWidth / 100) * el.progress) + "px";
                }
            },
            success(data, file) {
                el.response = file;
                if (el.progressBar) {
                    el.progressBar.classList.remove("running");
                    app.util.addCheckMark(el);
                }
            },
            error(data, error) {
                if (!el.errorShown) {
                    el.errorShown = true;
                    app.alert.error(error.header, error.message);
                    if (el.progressBar) {
                        el.progressBar.classList.add("failure");
                        el.progressBar.innerHTML = '<i class="fas fa-exclamation-triangle mx-auto"></i>';
                    }
                }
            },
            queuecomplete() {
                if (el.image) {
                    el.image.setAttribute("src", file.file);
                    el.image.style.opacity = "1";
                    el.image.style.filter = "blur(0px)";
                }
                if (el.imageBg) {
                    el.imageBg.style.backgroundImage = "url(" + file.file + ")";
                }
                if (el.overlay) {
                    el.overlay.style.opacity = "1";
                }
                el.progress = 0;
                el.errorShown = false;
                if (el.response && typeof el.response.callback === "string") {
                    eval(el.response.callback);
                }
                if (typeof el.callback === "string") {
                    eval(el.callback);
                }
            }
        });
    }

    activate(el) {
        if (typeof el.dz === "undefined") {
            el.uploadUrl = el.getAttribute("data-upload-url");
            el.params = JSON.parse(el.getAttribute("data-args"));
            el.callback = el.getAttribute("data-on-success");
            el.acceptedFiles = el.getAttribute("data-accepted-files");
            el.progressBar = el.querySelector(".image_upload_progress");
            el.progress = 0;
            el.response = null;
            el.overlay = el.querySelector(".overlay");
            el.imageBg = el.querySelector(".preview");
            el.clickable = true;
            el.errorShown = false;
            if (el.querySelectorAll(".clickable").length) {
                el.clickable = "#" + el.id.toString() + " .clickable";
            }
            el.dz = this.init(el);
        }
    }
}
